import type { ScoreFragment } from '~/client/features/Tournaments/graphql/ScoreFragment.generated';

type Props = {
  leaderboard?: ScoreFragment[];
  myScore?: ScoreFragment;
  isLast: boolean;
  leaderboardBefore: ScoreFragment[];
  leaderboardAfter: ScoreFragment[];
};

const initialListCount = 5;

const getLeadearboardWithUserInfo = ({
  leaderboard,
  isLast,
  leaderboardBefore,
  leaderboardAfter,
  myScore,
}: Props) => [
  [...(leaderboard?.slice(0, initialListCount) || [])],
  isLast
    ? [...leaderboardBefore, myScore]
    : [...leaderboardBefore, myScore, leaderboardAfter[0]],
];

export default getLeadearboardWithUserInfo;
